<template>
  <div class="history" :class="{ 'animate-flicker': loading }">
    <div class="nav-top">
      <div class="title">TUGAS SELESAI</div>
    </div>

    <div class="body">
      <div class="tab" v-if="$user.access == 'ADMIN'">
        <div>
          <span
            @click="tabActive = 'detail'"
            :class="{ active: tabActive == 'detail' }"
            >Detail</span
          >
        </div>
        <div>
          <span
            @click="tabActive = 'summary'"
            :class="{ active: tabActive == 'summary' }"
            >Summary</span
          >
        </div>
      </div>

      <div
        class="task"
        v-if="tabActive == 'summary' && $user.access == 'ADMIN'"
      >
        <ul>
          <ul>
            <li
              v-for="(item, index) in dataSummary"
              :key="index"
              @click="to('/user/' + item.id + '?nama=' + item.nama)"
            >
              <div>
                <p style="font-weight: 500; font-size: 14px">{{ item.nama }}</p>
              </div>
              <div>
                <p style="font-weight: 500">{{ item.total }}</p>
              </div>
            </li>
          </ul>
        </ul>
      </div>

      <div v-if="data.length <= 0">
        <p style="text-align: center; margin-top: 100px;">
          Belum ada tugas yang selesai
        </p>
      </div>

      <div class="task" v-if="tabActive == 'detail'">
        <ul>
          <li
            v-for="(item, index) in data"
            :key="index"
            @click="to('/detail/' + item.id + '?editable=0')"
          >
            <div>
              <div v-if="$user.access == 'ADMIN'">
                <small>{{ item.user }}</small>
              </div>
              <p>{{ item.nama }}</p>
              <small
                >Selesai pada
                {{ moment(item.complete_at).format("DD MMM YYYY") }}</small
              >
            </div>
            <div>
              <right />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as api from "../api/Api";

import Right from "./icons/Right.vue";

export default {
  name: "Home",
  components: {
    Right,
  },
  data() {
    return {
      loading: false,
      tabActive: "detail",
      data: [],
      dataSummary: [],
    };
  },
  methods: {
    moment,
    to(to) {
      setTimeout(() => {
        this.$router.push(to);
      }, 150);
    },
    loadSummary() {
      api.get("/v1/kendali_kerja/pekerjaanController/summaryUser").then((r) => {
        this.dataSummary = r.data;
      });
    },
    loadData() {
      api
        .get(
          "/v1/kendali_kerja/pekerjaanController/get?id_user=" +
            this.$user.id +
            "&status=COMPLETE"
        )
        .then((r) => {
          this.data = r.data;
        });
    },
  },
  mounted() {
    this.loadSummary();
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.history {
  background: #f2f3f7;
  min-height: 100vh;
  padding-bottom: 60px;
  .nav-top {
    background: #fff;
    box-shadow: 0px 2px 3px #ccc;
    display: grid;
    grid-template-columns: 1fr 50px;
    margin-bottom: 2px;
    .title {
      font-size: 14px;
      font-weight: bold;
      padding: 15px;
    }
    .save {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #009be7;
      color: #fff;
      &:active {
        background: #0087ca;
      }
    }
  }

  .body {
    .tab {
      padding: 15px 15px 0;
      display: grid;
      grid-template-columns: 1fr 1fr;

      div {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        display: block;
        font-size: 14px;
        width: 100%;
        padding: 10px;
        border-radius: 30px;
        text-align: center;
        &.active {
          background: #fff;
          box-shadow: 0px 3px 3px #ccc;
        }
      }
    }
    .task {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/History.vue